import { FC, useEffect, useState } from 'react';

import TableList from 'src/components/TableList/TableList';
import { PRODUCT_AND_PRICING_OFFERINGS_TABLE_HEADERS } from 'src/constants';

import { OfferList } from './ProductAndPricingOfferings';

interface ProductAndpricingProps {
    offerList?: OfferList;
}

const ProductAndpricing: FC<ProductAndpricingProps> = ({ offerList }) => {
    const [tableData, setTableData] = useState([]);

    const handleViewPricingOffer = () => {
        // TODO: implement the view products functionality
    };

    useEffect(() => {
        if (offerList?.length > 0) {
            const tableData = offerList.map((offer) => {
                return {
                    id: offer.id,
                    description: offer.name,
                    dateCreated: offer.createdAt,
                };
            });

            // Set the tableData in the state
            setTableData(tableData);
        } else {
            setTableData([]);
        }
    }, [offerList]);

    return (
        <TableList
            isTableModal
            isDashboardTable
            data={tableData}
            headers={PRODUCT_AND_PRICING_OFFERINGS_TABLE_HEADERS}
            addRecordCallBack={() => {}}
            handleViewRecord={handleViewPricingOffer}
            //TODO: add the delete functionality
            deleteRecordCallBack={() => {}}
        />
    );
};

export default ProductAndpricing;
